import { render, staticRenderFns } from "./OrderType.vue?vue&type=template&id=45d73eb6&scoped=true"
import script from "./OrderType.vue?vue&type=script&lang=js"
export * from "./OrderType.vue?vue&type=script&lang=js"
import style0 from "./OrderType.vue?vue&type=style&index=0&id=45d73eb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d73eb6",
  null
  
)

export default component.exports